import { OrderDetailContextProps } from '@euler/app/flows/order/types';
import { createContext, memo, ReactNode, useContext } from 'react';

export const OrderDetailContext = createContext<OrderDetailContextProps>(
  null as any,
);

export const useOrderDetailContext = () => useContext(OrderDetailContext);

export const OrderDetailProvider = memo(
  ({
    props,
    children,
  }: {
    props: OrderDetailContextProps;
    children?: ReactNode;
  }) => {
    return (
      <OrderDetailContext.Provider value={props}>
        {children}
      </OrderDetailContext.Provider>
    );
  },
);
